import React, { useState } from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import Section from '../components/layout/Section';
import PropertyCard from '../components/property/PropertyCard';
import Button from '../components/ui/Button';
import ImageModal from '../components/ui/ImageModal';

const PropertiesPage: React.FC = () => {
  const allProperties = [
    {
      id: 1,
      title: '2 Bedroom Semi-detached Bungalow',
      price: 30500000,
      location: 'Unique Solar Gardens Estate, SHEGO District, KARU',
      bedrooms: 2,
      bathrooms: 2,
      area: 350,
      images: ['/assets/photos/9.jpg', '/assets/photos/1.jpg', '/assets/photos/2.jpg'],
      status: 'For Sale',
      featured: true
    },
    {
      id: 2,
      title: '2 Bedroom Semi-detached Bungalow',
      price: 30500000,
      location: 'Unique Solar Gardens Estate, SHEGO District, KARU',
      bedrooms: 3,
      bathrooms: 2,
      area: 350,
      images: ['/assets/photos/10.jpg', '/assets/photos/3.jpg', '/assets/photos/4.jpg'],
      status: 'For Sale',
      featured: true
    },
    {
      id: 3,
      title: 'Luxury 3 Bedroom Bungalow',
      price: 38000000,
      location: 'Unique Solar Gardens Estate, SHEGO District, KARU',
      bedrooms: 3,
      bathrooms: 3,
      area: 350,
      images: ['/assets/photos/11.jpg', '/assets/photos/5.jpg', '/assets/photos/6.jpg'],
      status: 'For Sale',
      featured: true
    },
    {
      id: 4,
      title: '3 Bedroom Bungalow',
      price: 38000000,
      location: 'Unique Solar Gardens Estate, SHEGO District, KARU',
      bedrooms: 4,
      bathrooms: 4,
      area: 350,
      images: ['/assets/photos/12.jpg', '/assets/photos/7.jpg', '/assets/photos/8.jpg'],
      status: 'For Sale',
      featured: false
    },
    {
      id: 5,
      title: '3 Bedroom Semi-detached Bungalow',
      price: 34000000,
      location: 'Unique Solar Gardens Estate, SHEGO District, KARU',
      bedrooms: 5,
      bathrooms: 5,
      area: 350,
      images: ['/assets/photos/13.jpg', '/assets/photos/14.jpg', '/assets/photos/15.jpg'],
      status: 'For Sale',
      featured: false
    }
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImages, setModalImages] = useState<string[]>([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [modalTitle, setModalTitle] = useState('');

  const handleImageClick = (images: string[], title: string, clickedImage: string) => {
    setModalImages(images);
    setModalTitle(title);
    setCurrentImageIndex(images.indexOf(clickedImage));
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setModalImages([]);
    setCurrentImageIndex(0);
    setModalTitle('');
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % modalImages.length);
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      (prevIndex - 1 + modalImages.length) % modalImages.length
    );
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow pt-20"> {/* Added pt-20 to account for fixed navbar */}
        <Section background="light">
          <div className="text-center mb-12 mt-4">
            <h1 className="text-4xl font-bold text-primary mb-4">Our Properties</h1>
            <p className="text-gray-700 max-w-3xl mx-auto">
              Explore the diverse range of properties available at Unique Solar Gardens Estate. Find your dream home with sustainable living at its core.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {allProperties.map(property => (
              <PropertyCard 
                key={property.id}
                image={property.images[0]} // Display the first image as the thumbnail
                title={property.title}
                price={`₦${property.price.toLocaleString()}`}
                bedrooms={property.bedrooms}
                bathrooms={property.bathrooms}
                area={`${property.area} sqm`}
                tag={property.featured ? "Featured" : undefined}
                onImageClick={(clickedImage) => handleImageClick(property.images, property.title, clickedImage)}
              />
            ))}
          </div>

          <div className="text-center mt-12 mb-6">
            <Button variant="primary" size="lg">
              Load More Properties
            </Button>
          </div>
        </Section>
      </main>
      <Footer />
      {isModalOpen && (
        <ImageModal
          images={modalImages}
          currentIndex={currentImageIndex}
          onClose={handleCloseModal}
          onNext={handleNextImage}
          onPrev={handlePrevImage}
        />
      )}
    </div>
  );
};

export default PropertiesPage;